export const QUICK_LINK_LABEL_MAX_LENGTH = 128;
